import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "@/components/ui/dialog/Dialog";
import { Button } from "@/components/ui/button/Button";

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  secondaryAction?: React.ReactNode;
  confirmButtonColor?:
    | "red"
    | "indigo"
    | "slate"
    | "white"
    | "black"
    | "emerald"
    | "amber"
    | "blue"
    | "rose";
  isDestructive?: boolean;
  /** Whether the confirm action is in progress */
  isLoading?: boolean;
  /** Disable the confirm button without showing a loading state */
  confirmDisabled?: boolean;
  /** Dialog width (default md). */
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl";
}

export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = "Delete Resource List?",
  description = "Are you sure you want to delete this resource list? This action cannot be undone.",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  secondaryAction,
  confirmButtonColor,
  isDestructive = true,
  isLoading = false,
  confirmDisabled = false,
  size = "md",
}) => {
  const buttonColor = confirmButtonColor
    ? confirmButtonColor
    : isDestructive
      ? "red"
      : "indigo";

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} size={size}>
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>{description}</DialogBody>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          {cancelLabel}
        </Button>
        {secondaryAction}
        <Button
          color={buttonColor}
          onClick={onConfirm}
          disabled={isLoading || confirmDisabled}
          loading={isLoading}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
